import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  HStack,
  Heading,
  Switch,
  Text,
  Textarea,
  VStack,
  useColorMode,
} from "@chakra-ui/react";

export default function StudyNotes({
  ticker,
  note,
  onSave,
  isSaving = false,
}) {
  const { colorMode } = useColorMode();
  const [draft, setDraft] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  // Reset the textarea whenever the active ticker or persisted note changes.
  useEffect(() => {
    setDraft(note?.content ?? "");
  }, [ticker, note?.study_note_id, note?.updated_at, note?.content]);

  const persistedContent = note?.content ?? "";
  const isDirty = draft !== persistedContent;

  return (
    <VStack
      align="stretch"
      spacing={3}
      bg={colorMode === "light" ? "gray.50" : "gray.700"}
      borderRadius="md"
      p={3}
      h="100%"
      minW={{ base: "100%", lg: "320px" }}
      maxW={{ base: "100%", lg: "420px" }}
    >
      <HStack justify="space-between">
        <Heading size="sm">Notes {ticker ? `— ${ticker}` : ""}</Heading>
        <HStack>
          <Text fontSize="xs">Preview</Text>
          <Switch
            size="sm"
            isChecked={showPreview}
            onChange={(e) => setShowPreview(e.target.checked)}
            isDisabled={!ticker}
          />
        </HStack>
      </HStack>

      {ticker ? (
        showPreview ? (
          <Box
            flex="1"
            p={2}
            borderRadius="md"
            bg={colorMode === "light" ? "white" : "gray.800"}
            whiteSpace="pre-wrap"
            fontSize="sm"
            overflowY="auto"
            minH="240px"
          >
            {draft || (
              <Text color="gray.500" fontSize="xs">
                No notes yet — toggle preview off to start writing.
              </Text>
            )}
          </Box>
        ) : (
          <Textarea
            flex="1"
            placeholder={`Free-form notes on ${ticker}…`}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            bg={colorMode === "light" ? "white" : "gray.800"}
            minH="240px"
            fontSize="sm"
          />
        )
      ) : (
        <Box flex="1" display="flex" alignItems="center" justifyContent="center">
          <Text color="gray.500" fontSize="sm">
            Pick a ticker to start taking notes.
          </Text>
        </Box>
      )}

      <HStack justify="flex-end">
        <Button
          size="sm"
          colorScheme="blue"
          isDisabled={!ticker || !isDirty || isSaving}
          isLoading={isSaving}
          loadingText="Saving"
          onClick={() => ticker && onSave(ticker, draft)}
        >
          Save
        </Button>
      </HStack>
    </VStack>
  );
}
